<div class="main-all-container">
	<div class="bar-container">
		<div class="bar-section positive" [style.width.%]="positiveWidth">
			<span *ngIf="data.video != 0"></span>
		</div>
		<div class="bar-section neutral" [style.width.%]="neutralWidth">
			<span *ngIf="data.text != 0"></span>
		</div>
		<div class="bar-section negative" [style.width.%]="negativeWidth">
			<span *ngIf="data.audio != 0"></span>
		</div>
	</div>
	<span>{{ getTotal() }}</span>
</div>
